import { render } from "./Pagination.vue?vue&type=template&id=27837e9d"
import script from "./Pagination.vue?vue&type=script&scoped=true&lang=js"
export * from "./Pagination.vue?vue&type=script&scoped=true&lang=js"
script.render = render

export default script